"use client";

// LoadingIndicator bileşeni
interface LoadingIndicatorProps {
  isLoading: boolean;
}

function LoadingIndicator({ isLoading }: LoadingIndicatorProps) {
  if (!isLoading) return null;
  
  return (
    <div className="flex items-center justify-center gap-2">
      <div className="animate-pulse h-2 w-2 bg-black rounded-full"></div>
      <div className="animate-pulse h-2 w-2 bg-black rounded-full" style={{ animationDelay: '0.2s' }}></div>
      <div className="animate-pulse h-2 w-2 bg-black rounded-full" style={{ animationDelay: '0.4s' }}></div>
      <span className="text-[10px] font-mono uppercase text-gray-600">LOADING</span>
    </div>
  );
}

// NoResultsIndicator bileşeni
function NoResultsIndicator() {
  return (
    <div className="text-center">
      <div className="text-[18px] mb-2">🔍</div>
      <h3 className="text-[14px] font-mono uppercase mb-1">No Results Found</h3>
      <p className="text-[12px] text-gray-500">Try adjusting your filters or search terms</p>
    </div>
  );
}

interface StatusIndicatorsProps {
  isLoading: boolean;
  hasMore: boolean;
  visibleCount: number;
  totalCount: number;
  showScrollTop: boolean;
  onScrollToTop: () => void;
}

function MainStatusIndicator({
  isLoading,
  hasMore,
  visibleCount,
  totalCount,
  showScrollTop,
  onScrollToTop
}: StatusIndicatorsProps) {
  return (
    <>
      <div className="absolute left-4 bottom-4 z-20">
        {isLoading ? (
          <div className="py-1 px-3 bg-white text-[10px] font-mono uppercase text-black flex items-center gap-2 shadow-xs">
            <div className="animate-pulse h-1.5 w-1.5 bg-black rounded-full"></div>
            <div className="animate-pulse h-1.5 w-1.5 bg-black rounded-full" style={{ animationDelay: '0.2s' }}></div>
            <div className="animate-pulse h-1.5 w-1.5 bg-black rounded-full" style={{ animationDelay: '0.4s' }}></div>
            <span className="ml-1">LOADING {visibleCount}/{totalCount}</span>
          </div>
        ) : hasMore ? (
          <div className="py-1 px-3 bg-white text-[10px] font-mono uppercase text-gray-600 shadow-xs">
            SCROLL FOR MORE {visibleCount}/{totalCount}
          </div>
        ) : (
          <div className="py-1 px-3 bg-white text-[10px] font-mono uppercase text-gray-500 shadow-xs">
            END OF RESULTS {visibleCount}/{totalCount}
          </div>
        )}
      </div>
      
      {/* Scroll to top button */}
      {showScrollTop && (
        <button 
          onClick={onScrollToTop}
          className="absolute right-4 bottom-4 z-20 bg-white text-black py-1 px-3 text-[10px] font-mono uppercase hover:bg-gray-100 transition-all duration-200 shadow-xs flex items-center gap-1 animate-in fade-in"
          aria-label="Scroll to top"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 19V5M5 12l7-7 7 7"/>
          </svg>
          <span>TO TOP</span>
        </button>
      )}
    </>
  );
}

// StatusIndicators nesnesini oluştur ve export et
export const StatusIndicators = {
  LoadingIndicator,
  NoResultsIndicator,
  Main: MainStatusIndicator
};
